import { UniInput } from '@/design-system/components/inputs/UniInput';
import { UserEarnActionListResponseDataItem } from '@utx/utx-client';
import { View, SxProp } from 'dripsy';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PositionsStaking } from '../../screens/portfolio/tabs/PositionsStaking.web';
import { PageItemHeader } from '../page/PageItemHeader';

export interface PositionsProps {
  loading: boolean;
  data: Array<UserEarnActionListResponseDataItem>;
  paginatedProps: {
    currentPage: number;
    totalPages: number;
    onNextPage: () => void;
    onPrevPage: () => void;
  };
  onUpdate: () => void;
  refreshPortfolio: () => void;
  onFilterChange?: (value?: string) => void;
  showAmount?: boolean;
}

export const Positions: React.FC<PositionsProps> = ({
  loading,
  data,
  paginatedProps,
  onUpdate,
  onFilterChange,
  showAmount,
  refreshPortfolio
}) => {
  const { t } = useTranslation();
  return (
    <View sx={styles.container}>
      {/* Header */}
      <PageItemHeader
        title={t('earn-invest::glossary.positions')}
        suffix={[
          <UniInput
            prefixIcon="search"
            onValueChange={onFilterChange}
            placeholder={t('earn-invest::glossary.search-by-asset')}
            wrapperSx={{ flex: 1, maxWidth: '55%' }}
          />
        ]}
      />
      <View sx={{ height: '$8' }} />
      {/* Items */}
      <PositionsStaking
        loading={loading}
        data={data}
        onUpdate={onUpdate}
        paginatedProps={paginatedProps}
        showAmount={showAmount}
        refreshPortfolio={refreshPortfolio}
      />
    </View>
  );
};

enum StyleName {
  container = 'container',
  searchInput = 'searchInput',
  assetSelector = 'assetSelector'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    overflowY: 'visible',
    overflowX: 'hidden'
  },
  searchInput: { width: '100%', minWidth: '$80', maxWidth: '$130' },
  assetSelector: { width: '100%', maxWidth: '$100' }
};
